import { useState } from "react";
import Modal from "../reusable_components/Modal";
import postData from "../custom_functions/postData";
import { url } from "../utils/config";
import Input from "../reusable_components/Input";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";
import textValidator from "../custom_functions/textValidator";



function AddHoliday(props) {
        const [formData, setFormData ] = useState({})
        const [ missingFields, setMissingFields ] = useState([]);
        const [ inputErrors, setInputErrors ] = useState([]);
        const [ showInputError, setShowInputError ] = useState(false);

        const requiredFields = ['date', 'occassion'];

        function updateFormData(e) {
            const { name, value } = e.target;
            if(name === 'date' && value.length > 10) return
            const data = {...formData};
            data[name] = value;
            setFormData(data);
        }

        function addHoliday() {
            console.log(formData);
            if(!textValidator(formData.occassion)) return toast.error('Occassion can not contain number', { autoClose: 3000 })
            if(
                formData.date && new Date(formData.date).getTime() >= new Date(new Date(Date.now()).toLocaleDateString()).getTime()&&
                formData.occassion && formData.occassion.length > 0 &&
                !inputErrors.includes('error')
            ) {
                console.log('Validated')
                postData(`${url}/holiday`, formData, (error) => {
                    toast.error(error.response.data.message, { autoClose: 3000 })
                }, (data) => {
                    props.setShowForm(false);
                    toast.success(data.message, { autoClose: 3000 })
                    props.reload(1 + Math.random())
                })
            } else {
                let fields = Object.keys(formData);
                let miss = [];
                if (fields.length !== requiredFields.length) {
                    requiredFields.forEach(field => {
                        if(!fields.includes(field))  {
                            miss.push(field)
                        }
                    })
                };
                setMissingFields(miss);
                setShowInputError(true)
            }

        }

        return(
            <div className={modalContainer}>
                <div className="bg-white w-2/5 px-8 pt-8 pb-4 rounded-lg">
                    <div className={modalTitle}>ADD HOLIDAY</div>
                    <div>
                    <div className="grid grid-cols-3">
                            <label className={label}>Date</label>
                            <div className="col-span-2">
                                <Input 
                                    index={0}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    name="date" 
                                    type='date' 
                                    min={new Date(Date.now()).toLocaleDateString()}
                                    required={true}
                                    value={formData.date}
                                    className={inputStyle}
                                    placeHolder="Enter Date" 
                                    onChange={e => updateFormData(e)}
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-3">
                            <label className={label}>Occassion</label>
                            <div className="col-span-2">
                                <Input
                                    index={1}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    name="occassion"
                                    type='text' 
                                    maxLength={'100'}
                                    required={true}
                                    value={formData.occassion}
                                    className={inputStyle}
                                    placeHolder="Enter Occassion" 
                                    onChange={e => updateFormData(e)}
                                />
                            </div>
                        </div>
                        <div className="flex justify-between py-3 px-16 gap-8">
                            <button onClick={e => props.setShowForm(false)} className={btnCancel}>Cancel</button>
                            <Button clickHandler={e => addHoliday()} className={btnOne} name={'Submit'} />
                        </div>
                        <div className="text-red-500 font-semibold text-center">
                            {
                                showInputError && 'Please fill all the fields as directed!'
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

export default AddHoliday;